import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CssVariableSnippetComponent } from '../../../../shared/components/css-variable-snippet/css-variable-snippet.component';
import { StylingCardShellComponent } from '../styling-card-shell/styling-card-shell.component';

@Component({
    selector: 'avd-text-color-card',
    standalone: true,
    templateUrl: './text-color-card.component.html',
    styleUrls: ['./text-color-card.component.scss'],
    imports: [StylingCardShellComponent, CssVariableSnippetComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextColorCardComponent {
    @Input() cssVariable: string = '';
    @Input() label: string = '';
    @Input() inverseMode: boolean = false;

    get cssVariableName(): string {
        return this.cssVariable.trim();
    }

    get textColor(): string {
        if (!this.cssVariableName) {
            return 'inherit';
        }

        return `var(${this.cssVariableName})`;
    }

    get cssVariableSnippet(): string {
        return this.cssVariableName;
    }
}
